import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function sendInfoWanrSeenQuote() {
  return occFetch(occUrl("/quote/updateDSTError"), {
    method: "POST",
  });
}
